module.exports = __webpack_public_path__ + "static/duke&duck-2092ea2d679f9cc3dca460e4efb11ed6.png";